import { BASE_BE_URL } from "../AppEnv";
import {
  ALMSG_BADREQUEST_ERR,
  ALMSG_INTERNAL_ERR,
  ALMSG_UNAUTHORIZED_OP,
  BASE_MEDSTUDIO_SUBURL,
} from "../env";
import { Studio } from "../studio/interfaces";
import { StudioAdd } from "./SubscriptionStudio";

export async function addMedicalStudioX(addStudio: StudioAdd): Promise<string> {
  try {
    const response = await fetch(BASE_BE_URL + BASE_MEDSTUDIO_SUBURL, {
      method: "POST",
      headers: {
        Authorization: "Bearer ",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addStudio),
    });

    if (response.ok) return "ok";

    if (response.status == 400) return ALMSG_BADREQUEST_ERR;
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}


export async function checkStudioName(studio: Studio): Promise<boolean> {
  try {
    const response = await fetch(`${BASE_BE_URL}${BASE_MEDSTUDIO_SUBURL}check-name`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ nameSignIn: studio.nameSignIn }),
    });

    if (response.ok) {
      const data = await response.json();
      return data.exists;
    }

    return false;
  } catch (error: any) {
    return false;
  }
}



export async function checkUsernameAvailability(nameSignIn: string): Promise<string> {
  try {
    const response = await fetch(BASE_BE_URL + "/auth" + '/check-username', {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ nameSignIn }),
    });

    // Log della risposta per verificare cosa ricevi dal backend
    console.log("Response status:", response.status);
    
    const responseText = await response.text(); // Leggi il corpo come testo prima
    console.log("Response body:", responseText); // Log del corpo della risposta
    
    // Se la risposta è OK, prova a fare il parsing come JSON
    if (response.ok) {
      const data = JSON.parse(responseText); // Usa il testo per fare il parsing JSON
      return data.message; // Restituisci direttamente il messaggio
    }

    return "Errore interno"; // Qualche errore imprevisto
  } catch (error) {
    console.error("Errore di connessione:", error); // Log dell'errore
    return "Errore di connessione";
  }
}



export async function checkDoctorUsernameAvailability(username: string): Promise<string> {
  try {
    const response = await fetch(BASE_BE_URL + "/doctor" + '/check-doctor-username', {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username }),
    });

    // Log della risposta per verificare cosa ricevi dal backend
    console.log("Response status:", response.status);
    
    const responseText = await response.text(); // Leggi il corpo come testo prima
    console.log("Response body:", responseText); // Log del corpo della risposta
    
    // Se la risposta è OK, prova a fare il parsing come JSON
    if (response.ok) {
      const data = JSON.parse(responseText); // Usa il testo per fare il parsing JSON
      return data.message; // Restituisci direttamente il messaggio
    }

    return "Errore interno"; // Qualche errore imprevisto
  } catch (error) {
    console.error("Errore di connessione:", error); // Log dell'errore
    return "Errore di connessione";
  }
}


export async function checkCfAvailability(vat: string): Promise<string> {
  try {
    const response = await fetch(BASE_BE_URL + "/auth" + '/check-cf', {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ vat }),
    });

    // Log della risposta per verificare cosa ricevi dal backend
    console.log("Response status Vat:", response.status);
    
    const responseText = await response.text(); // Leggi il corpo come testo prima
    console.log("Response body Vat:", responseText); // Log del corpo della risposta
    
    // Se la risposta è OK, prova a fare il parsing come JSON
    if (response.ok) {
      const data = JSON.parse(responseText); // Usa il testo per fare il parsing JSON
      return data.message; // Restituisci direttamente il messaggio
    }

    return "Errore interno"; // Qualche errore imprevisto
  } catch (error) {
    console.error(" Vat Errore di connessione:", error); // Log dell'errore
    return " Vat Errore di connessione";
  }
}


export async function checkDoctorEmailAvailability(email: string): Promise<string> {
  try {
    const response = await fetch(BASE_BE_URL + "/auth" + '/check-doctor-email', {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });

    // Log della risposta per verificare cosa ricevi dal backend
    console.log("Response status Email:", response.status);
    
    const responseText = await response.text(); // Leggi il corpo come testo prima
    console.log("Response body Email:", responseText); // Log del corpo della risposta
    
    // Se la risposta è OK, prova a fare il parsing come JSON
    if (response.ok) {
      const data = JSON.parse(responseText); // Usa il testo per fare il parsing JSON
      return data.message; // Restituisci direttamente il messaggio
    }

    return "Errore interno"; // Qualche errore imprevisto
  } catch (error) {
    console.error("Email Errore di connessione:", error); // Log dell'errore
    return "Email Errore di connessione";
  }
}